import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useCompleteInventoryMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const inventoryCompleteModal: any = {};

export const InventoryCompleteModal = () => {
  const { mutate } = useCompleteInventoryMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    inventoryCompleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(inventoryCompleteModal).forEach((key) => {
      if (key !== 'open') delete inventoryCompleteModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: inventoryCompleteModal.id, yardId: inventoryCompleteModal.yardId },
      {
        onSuccess: () => {
          setOpen(false);
          enqueueSnackbar(MESSAGES.INVENTORY.SUCCESS.COMPLETED, 'success');
          inventoryCompleteModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.INVENTORY.ERROR.NOT_COMPLETED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'inventory-complete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.inventoryCompleteTitle', {
            yardName: inventoryCompleteModal.yardName,
          })}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
